import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';

import { AdminService }  from '../services/admins/admin.service';

import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';
import { Auth } from '../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-admins',
  templateUrl: 'admins.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class AdminsComponent extends UsersComponent {

  constructor(
    protected router: Router,
    protected adminService: AdminService,
  protected providerService:ProviderService,
  protected auth: Auth) { super(router, adminService,providerService); }

  hasBOUsersPermission:Boolean = false;

  protected getDetailUrl(): string {

    return '/admin/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'admin';
  };

  protected getUsersString(): string {

    return 'Admins';
  };

  ngOnInit(): void {
    this.getUsers({ limit: 1000 })
    this.hasBOUsersPermission = this.auth.hasBOUsersPermission();
}


  add(): void {

    if (this.createCalled) {

      return;
    }
    if (this.newUser.name==undefined || this.newUser.password==undefined || this.newUser.email==undefined) {
      this.alertAdd=true;
      return;
    }
    let name = this.newUser.name.trim();
    if (!name) {
      this.alertAdd=true;
      return;
    }

    let password = this.newUser.password.trim();
    if (!password || password.length < 8) {
      this.alertAdd=true;
      return;
    }

    let email = this.newUser.email.trim();
    if (!email) {
       this.alertAdd=true;
      return;
    }

    this.createCalled = true;
    this.adminService.create({
      name: name,
      password: password,
      email: email
    })
      .then(user => {

        this.createCalled = false;
        this.pushOrdered(user);
        this.selectedUser = null;
        this.newUser = {};
        this.configPages()
        this.alertCreated=true;
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        alert(error.message)
        return Promise.reject(error.message || error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admins/admins.component.ts